import { useDataSubmit, useDataChange, useDataValue } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let bulk_task_ids = useDataValue({
    context: 'selected',
    path: 'bulk_task_ids',
    viewPath: props.viewPath,
  })

  let person = useDataValue({
    context: 'person',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'selected',
    path: 'bulk_task_ids',
    viewPath: props.viewPath,
  })

  return function onClick() {
    if (person) {
      submit({
        type: 'set_bulk_tasks_assignee',
        task_and_assignee_ids: bulk_task_ids.map(task => ({
          id: task,
          user_id: person.id,
        })),
      })

      change([])
    }
  }
}
